import React,{useEffect,useRef,useState} from 'react';
import {css} from "emotion";
import { disableBodyScroll , enableBodyScroll , clearAllBodyScrollLocks } from 'body-scroll-lock';
import CheckBox from '../../common/material-easy-ui/input/CheckBox';
import IconEasyArrow from '../../common/material-easy-ui/icon/IconEasyClose'



const ModalValidation = (props) =>{

  const [check1,setCheck1] = useState(false)
  const [check2,setCheck2] = useState(false)
  const [check3,setCheck3] = useState(false)
  const [check4,setCheck4] = useState(false)

  const refModal = useRef(null);

  useEffect(()=>{
    disableBodyScroll(refModal);
      return () =>{
        clearAllBodyScrollLocks();
      }
  },[]);


  const onChangeCheck1 = (id,value) =>{setCheck1(!check1)}
  const onChangeCheck2 = (id,value) =>{ setCheck2(!check2)}
  const onChangeCheck3 = (id,value) =>{ setCheck3(!check3)}
  const onChangeCheck4 = (id,value) =>{ setCheck4(!check4)}

  const onValid = () =>{
    if(check1 && check2 && check3 && check4 && !props.loader){
      props.onValid();
    }
    else
      return false;
  }

  return(
    <div  className={css`top:0px;left:0px;position:fixed;z-index:100;width:100%;height:100%;background-color:rgba(0, 0, 0,0.5);display:flex;align-items:center;justify-content:center`}>
        <div ref={refModal} className={css`
          @media (max-width: 678px) {
                  border-radius:0px;
                  margin-top:0px;
                  margin-left:0px;
                  width:100%;
                  height:100vh;


              };
              box-sizing:border-box;background-color:white;border-radius:10px;width:600px;`}>
          <div className={css`

          height:40px;
          border-bottom:1px solid #ededed;
          width:100%;display:
          flex;
          justify-content:flex-end;
          align-items:center;`}>
            <div onClick={props.onCloseBox} className={css`margin-right:20px;cursor:pointer`}><IconEasyArrow size={20}/></div>
          </div>
          <div className={css`
             @media (max-width: 678px){
            height:calc(100% - 40px);
          };overflow-y:auto;padding-top:20px;padding-left:40px;padding-right:40px;box-sizing:border-box`}>
          <div className={css`font-size:15px;color:#5e5e5e`}>Acceptation des termes légaux et des conditions générales d’utilisation : </div>
            <div className={css`margin-top:20px`}>
              <div className={css`margin-top:20px`}>

                  <CheckBox
                  checked={check1}
                  id={1}
                  onChange={onChangeCheck1}
                  label={'J’atteste être propriétaire du navire loué et ne mettre en location qu’un seul navire m’appartenant'}/></div>

                <div className={css`margin-top:20px`}>
                <CheckBox
                checked={check2}
                id={2}
                onChange={onChangeCheck2}
                label={'Je certifie exact les renseignements fournis'}/></div>

                <div className={css`margin-top:20px`}>
                <CheckBox
                checked={check3}
                id={3}
                onChange={onChangeCheck3}
                 label={'J’atteste être autorisé à pratiquer une activité de location depuis mon port de départ'}/></div>

                  <div className={css`margin-top:20px`}>
                  <CheckBox
                      checked={check4}
                      onChange={onChangeCheck4}
                      id={4}
                      label={"J’atteste avoir pris connaissance des conditions d’exercice de l’activité en cœur de Parc national et être en conformité avec ces conditions d’exercice, à savoir :\n-Mon activité de location fait l’objet d’un contrat écrit avec le locataire du navire.\n-je dispose d’une assurance du navire permettant l’activité de location.\n-Le navire loué fait l’objet d’une vérification spéciale annuelle conformément à l’article 240-3.01 de la division 240.".split('\n').map((item, key) => {
                            return (
                              <span className={css`&:nth-child(2){margin-top:100px};font-size:13px`} key = {key}>
                                  {item}
                                  <br/>
                                </span>
                            )
                              })}/>
                    </div>
                    <div className={css`font-size:13px;margin-top:20px`}>J’ai pris connaissance que l’autorisation du Parc national pour exercer l’activité au cœur du Parc national ne dispense en aucun cas des autorisations délivrées par d’autres autorités (autorités portuaires notamment) ni du cadre réglementaire d’exercice de droit commun relatif à l’activité (réglementation fiscale, autorisation portuaire). </div>

                      <div onClick={onValid}  className={css`&:hover{background-color:${(check1 && check2 && check3 && check4) && '#5c9ebf'}};cursor:pointer;background-color:${(check1 && check2 && check3 && check4) ? '#0085C6' : '#a3a3a3'};color:white;height:50px;line-height:50px;border-radius:10px;text-align:center;margin-top:40px`}>Valider</div>
                      <div className={css`height:40px`}></div>
                  </div>
                </div>
        </div>
    </div>
  )
}

export default ModalValidation;
